import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useData } from '../contexts/DataContext';
import TabsComponent from '../components/ui/TabsComponent';
import StatusBadge from '../components/ui/StatusBadge';
import CapacityBar from '../components/ui/CapacityBar';
import { db, COLLECTIONS } from '../firebase/config';
import { deleteDoc, doc } from 'firebase/firestore';

import { 
  Plus, 
  Search, 
  Filter, 
  Calendar,
  Users,
  BarChart3,
  FileText,
  ChevronRight,
  AlertCircle,
  CheckCircle,
  Clock,
  XCircle,
  FolderOpen,
  Activity,
  CheckSquare,
  Edit,
  Trash2,
  Info,
  Building2,
  AlertTriangle,
  Globe,
  X,
  List,
  User
} from 'lucide-react';

const Projects = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { currentUser } = useAuth();
  const { projects, tasks, users, departments, teams, createProject, updateProject, updateTask } = useData();
  const [showNewProject, setShowNewProject] = useState(false);
  const [showEditProject, setShowEditProject] = useState(false);
  const [showStatusModal, setShowStatusModal] = useState(false);
  const [editProject, setEditProject] = useState(null);
  const [statusProject, setStatusProject] = useState(null);
  const [activeTab, setActiveTab] = useState('overview');
  const [showNewTaskModal, setShowNewTaskModal] = useState(false);
const [newTaskSubtask, setNewTaskSubtask] = useState('');
  const [mainTab, setMainTab] = useState(
    currentUser?.role === 'team_manager' ? 'team' : 
    currentUser?.role === 'employee' ? 'personal' : 'management'
  );
  const [searchTerm, setSearchTerm] = useState('');
  const [filterScope, setFilterScope] = useState('all');
  const [filterStatus, setFilterStatus] = useState('all');
  const [filterPriority, setFilterPriority] = useState('all');
  const [filterDepartment, setFilterDepartment] = useState('all');
  const [filterTeam, setFilterTeam] = useState('all');
  const [newProjectTask, setNewProjectTask] = useState('');
  

  // Helper function to check if project should be hidden from current user
  const shouldHideProject = (project) => {
    const hidePersonalProject = project.scope === 'personal' && project.assigneeId !== currentUser.id && project.createdBy !== currentUser.id;
    return hidePersonalProject;
  };

  // Get single project if ID is provided
  const selectedProject = id ? projects.find(p => p.id === id) : null;

  // Project status calculation - תמיד מחזיר באנגלית
// Project status calculation - תמיד מחזיר באנגלית
function getProjectStatus(project) {
  // אם יש סטטוס ישיר, תמיד החזר באנגלית
  if (project.status) {
    // המרה מעברית לאנגלית אם צריך
    if (project.status === 'ממתין לעבודה') return 'pending';
    if (project.status === 'פרויקט בתהליך') return 'in_progress';
    if (project.status === 'פרויקט הושלם') return 'completed';
    // אם כבר באנגלית
    if (project.status === 'pending' || project.status === 'in_progress' || project.status === 'completed') {
      return project.status;
    }
  }
  
  const projectTasks = tasks.filter(t => t.projectId === project.id);
  
  if (projectTasks.length === 0) {
    return 'pending';
  }
  
  const completedTasks = projectTasks.filter(t => t.status === 'הושלם').length;
  const activeTasks = projectTasks.filter(t => t.status !== 'הושלם');
  
  if (completedTasks === projectTasks.length) {
    return 'completed';
  }
  
  if (activeTasks.length > 0) {
    return 'in_progress';
  }
  
  return 'pending';
}    
   const ProjectTasks = ({ project, tasks }) => {
  const navigate = useNavigate();
  const [showNewTaskModal, setShowNewTaskModal] = useState(false);
  const [newTaskSubtask, setNewTaskSubtask] = useState('');
  const { createTask } = useData();
  const { currentUser } = useAuth();
  const { teams, departments } = useData();
  
  const [newTask, setNewTask] = useState({
    title: '',
    description: '',
    assigneeId: currentUser?.id || '',
    assigneeIds: [currentUser?.id || ''],
    teamMembers: [],
    priority: 'important_not_urgent',
    dueDate: '',
    dueTime: '09:00', // שעת יעד ברירת מחדל
    estimate: 0,
    status: 'ממתין לעבודה',
    projectId: project.id,
    departmentId: project.departmentId || '',
    teamId: project.teamId || '',
    scope: project.scope || 'personal',
    subtasks: []
  });

  const handleCreateTask = async (e) => {
    e.preventDefault();
    try {
      const taskData = {
        ...newTask,
        createdBy: currentUser.id,
        creatorId: currentUser.id,
        projectId: project.id,
        scope: project.scope,
        departmentId: project.departmentId || '',
        teamId: project.teamId || ''
      };
      
      await createTask(taskData);
      
      // Reset form
      setNewTask({
        title: '',
        description: '',
        assigneeId: currentUser?.id || '',
        assigneeIds: [currentUser?.id || ''],
        teamMembers: [],
        priority: 'important_not_urgent',
        dueDate: '',
        estimate: 0,
        status: 'ממתין לעבודה',
        projectId: project.id,
        departmentId: project.departmentId || '',
        teamId: project.teamId || '',
        scope: project.scope || 'personal',
        subtasks: []
      });
      setNewTaskSubtask('');
      setShowNewTaskModal(false);
    } catch (error) {
      console.error('Error creating task:', error);
      alert('שגיאה ביצירת המשימה');
    }
  };

  return (
    <div>
      {/* Header with Add Task Button */}
      <div className="flex justify-between items-center mb-4">
        <h3 className="text-lg font-semibold">משימות הפרויקט</h3>
        <button
          onClick={() => setShowNewTaskModal(true)}
          className="flex items-center gap-2 px-4 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700"
        >
          <Plus size={20} />
          משימה חדשה
        </button>
      </div>

      {/* Tasks List */}
      {tasks.length === 0 ? (
        <div className="text-center py-8">
          <p className="text-gray-500">אין משימות בפרויקט זה</p>
        </div>
      ) : (
        <div className="space-y-3">
          {tasks.map(task => (
            <div 
              key={task.id} 
              className="bg-white p-4 rounded-lg border hover:shadow-md transition-shadow cursor-pointer"
              onClick={() => navigate(`/tasks/${task.id}`)}
            >
              <div className="flex items-center justify-between">
                <div className="flex-1">
                  <h4 className="font-medium">{task.title}</h4>
                  {task.description && (
                    <p className="text-sm text-gray-600 mt-1">{task.description}</p>
                  )}
                </div>
                <StatusBadge status={task.status} size="sm" />
              </div>
            </div>
          ))}
        </div>
      )}

      {/* New Task Modal */}
      {showNewTaskModal && (
        <div 
          className="fixed inset-0 bg-black bg-opacity-60 backdrop-blur-sm flex items-center justify-center z-50 p-4"
          onClick={() => setShowNewTaskModal(false)}
        >
          <div 
            className="bg-white rounded-2xl shadow-2xl w-full max-w-2xl max-h-[90vh] overflow-y-auto border border-gray-100"
            onClick={(e) => e.stopPropagation()}
          >
            {/* Header */}
            <div className="bg-gradient-to-r from-purple-600 to-purple-700 text-white p-6 rounded-t-2xl">
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 bg-white bg-opacity-20 rounded-full flex items-center justify-center">
                    <Plus size={24} />
                  </div>
                  <div>
                    <h2 className="text-2xl font-bold">משימה חדשה</h2>
                    <p className="text-purple-100 text-sm">צור משימה חדשה ב{project.name}</p>
                  </div>
                </div>
                <button
                  onClick={() => setShowNewTaskModal(false)}
                  className="w-8 h-8 bg-white bg-opacity-20 rounded-full flex items-center justify-center hover:bg-white hover:bg-opacity-30 transition-all"
                >
                  <X size={20} />
                </button>
              </div>
            </div>

            {/* Form Content */}
            <div className="p-6">
              <form onSubmit={handleCreateTask}>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  {/* Left Column */}
                  <div className="space-y-4">
                    {/* Title */}
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2 flex items-center gap-2">
                        <FileText size={16} className="text-purple-600" />
                        כותרת המשימה
                      </label>
                      <input
                        type="text"
                        value={newTask.title}
                        onChange={(e) => setNewTask({...newTask, title: e.target.value})}
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-purple-500 transition-all"
                        placeholder="הכנס כותרת למשימה..."
                        required
                      />
                    </div>
                    
                    {/* Description */}
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2 flex items-center gap-2">
                        <FileText size={16} className="text-purple-600" />
                        תיאור המשימה
                      </label>
                      <textarea
                        value={newTask.description}
                        onChange={(e) => setNewTask({...newTask, description: e.target.value})}
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-purple-500 transition-all h-24 resize-none"
                        placeholder="תאר את המשימה בפירוט..."
                        rows="3"
                      />
                    </div>

                    {/* Priority */}
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2 flex items-center gap-2">
                        <AlertTriangle size={16} className="text-purple-600" />
                        עדיפות
                      </label>
                      <select
                        value={newTask.priority}
                        onChange={(e) => setNewTask({...newTask, priority: e.target.value})}
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-purple-500 transition-all"
                      >
                        <option value="important_urgent">🔥 חשוב ודחוף</option>
                        <option value="important_not_urgent">⭐ חשוב ולא דחוף</option>
                        <option value="not_important_urgent">⚡ לא חשוב ודחוף</option>
                        <option value="not_important_not_urgent">📝 לא חשוב ולא דחוף</option>
                      </select>
                    </div>
                  </div>

                  {/* Right Column */}
                  <div className="space-y-4">
                    {/* Due Date */}
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2 flex items-center gap-2">
                        <Calendar size={16} className="text-purple-600" />
                        תאריך יעד
                      </label>
                      <input
                        type="date"
                        value={newTask.dueDate}
                        onChange={(e) => setNewTask({...newTask, dueDate: e.target.value})}
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-purple-500 transition-all"
                      />
                    </div>

                    {/* Due Time */}
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2 flex items-center gap-2">
                        <Clock size={16} className="text-purple-600" />
                        שעת יעד
                      </label>
                      <input
                        type="time"
                        value={newTask.dueTime}
                        onChange={(e) => setNewTask({...newTask, dueTime: e.target.value})}
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-purple-500 transition-all"
                      />
                    </div>

                    {/* Estimate */}
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2 flex items-center gap-2">
                        <Clock size={16} className="text-purple-600" />
                        הערכת זמן
                      </label>
                      <input
                        type="number"
                        value={newTask.estimate}
                        onChange={(e) => setNewTask({...newTask, estimate: parseInt(e.target.value) || 0})}
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-purple-500 transition-all"
                        min="0"
                        placeholder="שעות"
                      />
                    </div>

                    {/* Assignee */}
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2 flex items-center gap-2">
                        <User size={16} className="text-purple-600" />
                        אחראי על המשימה
                      </label>
                      <select
                        value={newTask.assigneeId}
                        onChange={(e) => setNewTask({
                          ...newTask, 
                          assigneeId: e.target.value,
                          assigneeIds: [e.target.value]
                        })}
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-purple-500 transition-all"
                      >
                        <option value={currentUser?.id}>{currentUser?.name || 'אני'}</option>
                        {project.teamMembers && project.teamMembers
                          .filter(memberId => memberId !== currentUser?.id)
                          .map(memberId => {
                            const user = users.find(u => u.id === memberId);
                            return user ? (
                              <option key={user.id} value={user.id}>{user.name}</option>
                            ) : null;
                          })}
                      </select>
                    </div>
                  </div>

                  {/* Subtasks - Full Width */}
                  <div className="col-span-2">
                    <label className="block text-sm font-medium text-gray-700 mb-2 flex items-center gap-2">
                      <List size={16} className="text-purple-600" />
                      תתי משימות
                    </label>
                    <div className="space-y-2">
                      {newTask.subtasks && newTask.subtasks.length > 0 && (
                        <div className="space-y-2">
                          {newTask.subtasks.map((subtask, index) => (
                            <div key={index} className="flex items-center gap-2">
                              <div className="flex-1 px-3 py-2 bg-gray-50 border border-gray-200 rounded-lg text-sm">
                                {subtask}
                              </div>
                              <button
                                type="button"
                                onClick={() => {
                                  const updatedSubtasks = newTask.subtasks.filter((_, i) => i !== index);
                                  setNewTask({...newTask, subtasks: updatedSubtasks});
                                }}
                                className="w-8 h-8 bg-red-100 hover:bg-red-200 text-red-600 rounded-lg flex items-center justify-center transition-all"
                              >
                                <X size={16} />
                              </button>
                            </div>
                          ))}
                        </div>
                      )}
                      <div className="flex gap-2">
                        <input
                          type="text"
                          value={newTaskSubtask || ''}
                          onChange={(e) => setNewTaskSubtask(e.target.value)}
                          onKeyPress={(e) => {
                            if (e.key === 'Enter' && newTaskSubtask.trim()) {
                              e.preventDefault();
                              const updatedSubtasks = [...(newTask.subtasks || []), newTaskSubtask.trim()];
                              setNewTask({...newTask, subtasks: updatedSubtasks});
                              setNewTaskSubtask('');
                            }
                          }}
                          className="flex-1 px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-purple-500 transition-all"
                          placeholder="הוסף תת משימה חדשה..."
                        />
                        <button
                          type="button"
                          onClick={() => {
                            if (newTaskSubtask && newTaskSubtask.trim()) {
                              const updatedSubtasks = [...(newTask.subtasks || []), newTaskSubtask.trim()];
                              setNewTask({...newTask, subtasks: updatedSubtasks});
                              setNewTaskSubtask('');
                            }
                          }}
                          className="px-4 py-2 bg-purple-100 hover:bg-purple-200 text-purple-700 rounded-lg flex items-center gap-2 transition-all font-medium"
                        >
                          <Plus size={16} />
                          הוסף
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                
                {/* Action Buttons */}
                <div className="mt-8 flex gap-3 justify-end pt-6 border-t border-gray-100">
                  <button
                    type="button"
                    onClick={() => setShowNewTaskModal(false)}
                    className="px-6 py-3 text-gray-600 hover:text-gray-800 hover:bg-gray-100 rounded-xl transition-all font-medium"
                  >
                    ביטול
                  </button>
                  <button
                    type="submit"
                    className="px-8 py-3 bg-gradient-to-r from-purple-600 to-purple-700 text-white rounded-xl hover:from-purple-700 hover:to-purple-800 transition-all font-semibold shadow-lg hover:shadow-xl transform hover:scale-105"
                  >
                    <div className="flex items-center gap-2">
                      <Plus size={20} />
                      צור משימה
                    </div>
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
  // Filter projects based on search and filters
  const filteredProjects = projects.filter(project => {
    // First filter by user role and access
    let hasAccess = false;
    
    if (currentUser?.role === 'org_admin' || currentUser?.role === 'ceo' || currentUser?.role === 'deputy_ceo') {
      if (mainTab === 'management') {
        // מנהלים עליונים רואים כל הפרויקטים הארגוניים כולל פרויקטי צוותים
        hasAccess = (project.scope === 'managerial' || project.scope === 'department' || 
                    (project.scope === 'managerial' && project.teamId));
      } else {
        hasAccess = (project.scope === 'personal' && 
                    (project.createdBy === currentUser.id || project.assigneeId === currentUser.id));
      }
    } else if (currentUser?.role === 'dept_manager') {
      if (mainTab === 'management') {
        // מנהל מחלקה רואה גם פרויקטים של צוותים במחלקה שלו
        hasAccess = project.departmentId === currentUser.departmentId ||
                   (project.teamId && teams.some(team => team.id === project.teamId && team.departmentId === currentUser.departmentId));
      } else {
        hasAccess = (project.scope === 'personal' && 
                    (project.createdBy === currentUser.id || project.assigneeId === currentUser.id));
      }
    } else if (currentUser?.role === 'team_manager') {
      if (mainTab === 'team') {
        const userTeam = teams.find(team => team.managerId === currentUser.id);
        hasAccess = userTeam && (
          project.teamId === userTeam.id ||
          (project.scope === 'managerial' && project.teamId === userTeam.id)
        );
      } else {
        hasAccess = (project.scope === 'personal' && 
                    (project.createdBy === currentUser.id || project.assigneeId === currentUser.id));
      }
    } else if (currentUser?.role === 'employee') {
      if (mainTab === 'management') {
        hasAccess = (project.scope === 'managerial' && 
                    (project.assigneeId === currentUser.id ||
                     (Array.isArray(project.teamMembers) && project.teamMembers.includes(currentUser.id))));
      } else {
        hasAccess = (project.scope === 'personal' && 
                    (project.createdBy === currentUser.id || project.assigneeId === currentUser.id));
      }
    }
    
    if (!hasAccess) return false;
    
    if (shouldHideProject(project)) return false;
    
    // Apply search filter
    const matchesSearch = project.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         project.description?.toLowerCase().includes(searchTerm.toLowerCase());
    
    // Apply scope filter
    const matchesScope = filterScope === 'all' || project.scope === filterScope;
    
    // Apply status filter - משווה לערכים באנגלית
    const projectStatus = getProjectStatus(project);
    const matchesStatus = filterStatus === 'all' || projectStatus === filterStatus;
    
    // Apply priority filter
    const matchesPriority = filterPriority === 'all' || project.priority === filterPriority;
    // Apply department filter - חדש
    const matchesDepartment = filterDepartment === 'all' || project.departmentId === filterDepartment;
    
    // Apply team filter - חדש למנכל וסמנכל
    const matchesTeam = filterTeam === 'all' || project.teamId === filterTeam;
    
    return matchesSearch && matchesScope && matchesStatus && matchesPriority && matchesDepartment && matchesTeam;
  });

  // New project form
  const [newProject, setNewProject] = useState({
    name: '',
    description: '',
    scope: currentUser?.role === 'employee' ? 'personal' : 'managerial',
    priority: 'important_not_urgent',
    departmentId: currentUser?.departmentId || '',
    teamId: '',
    startDate: '',
    endDate: '',
    teamMembers: currentUser?.role === 'employee' ? [currentUser.id] : [],
    assigneeId: '',
    projectTasks: []
  });

  const handleCreateProject = async (e) => {
    e.preventDefault();
    try {
      const projectId = await createProject(newProject);
      setShowNewProject(false);
      setNewProject({
        name: '',
        description: '',
        scope: currentUser?.role === 'employee' ? 'personal' : 'managerial',
        priority: 'important_not_urgent',
        departmentId: currentUser?.departmentId || '',
        teamId: '',
        startDate: '',
        endDate: '',
        teamMembers: currentUser?.role === 'employee' ? [currentUser.id] : [],
        assigneeId: '',
        projectTasks: []
      });
      setNewProjectTask('');
      navigate(`/projects/${projectId}`);
    } catch (error) {
      console.error('Error creating project:', error);
    }
  };

  // Edit project function
const handleEditProject = (project) => {
  console.log('Edit project clicked:', project.name);
  setEditProject({...project});
  setShowEditProject(true);
};

  // Change project status function
const handleChangeStatus = (project) => {
  console.log('Change status clicked:', project.name);
  setStatusProject({...project});
  setShowStatusModal(true);
}; 

  // Check if user can delete project
  const canDeleteProject = (project) => {
    // מנכ"ל, סמנכ"ל ומנהל ארגון - כל הפרויקטים
    if (currentUser?.role === 'ceo' || currentUser?.role === 'deputy_ceo' || currentUser?.role === 'org_admin') {
      return true;
    }
    
    // מנהל מחלקה - פרויקטים של המחלקה שלו
    if (currentUser?.role === 'dept_manager') {
      return project.departmentId === currentUser.departmentId;
    }
    
    // מנהל צוות - פרויקטים של הצוות שלו
    if (currentUser?.role === 'team_manager') {
      return project.teamId === currentUser.teamId;
    }
    
    // עובד - רק פרויקטים אישיים שלו
    if (currentUser?.role === 'employee') {
      return project.scope === 'personal' && project.createdBy === currentUser.id;
    }
    
    return false;
  };

  // Delete project function
  const handleDeleteProject = async (project) => {
    if (window.confirm(`האם אתה בטוח שברצונך למחוק את הפרויקט "${project.name}"?`)) {
      try {
        await deleteDoc(doc(db, COLLECTIONS.PROJECTS, project.id));
        navigate('/projects');
      } catch (error) {
        console.error('Error deleting project:', error);
        alert('שגיאה במחיקת הפרויקט');
      }
    }
  };

  // If showing project details
  if (selectedProject) {
    const projectTasks = tasks.filter(t => t.projectId === selectedProject.id);
    const projectStatus = getProjectStatus(selectedProject);
    const completedTasks = projectTasks.filter(t => t.status === 'הושלם').length;
    const totalTasks = projectTasks.length;
    const progress = totalTasks > 0 ? (completedTasks / totalTasks) * 100 : 0;

    const teamMembers = selectedProject.teamMembers?.map(memberId => 
      users.find(u => u.id === memberId)
    ).filter(member => member && member.name) || [];

    // Tabs for project details
    const projectTabs = [
      {
        id: 'overview',
        label: 'סקירה כללית',
        icon: Info,
        content: <ProjectOverview project={selectedProject} tasks={projectTasks} teamMembers={teamMembers} departments={departments} />
      },
      {
        id: 'tasks',
        label: 'משימות',
        icon: CheckSquare,
        badge: totalTasks.toString(),
        content: <ProjectTasks project={selectedProject} tasks={projectTasks} />
      },
      {
        id: 'team',
        label: 'צוות',
        icon: Users,
        badge: teamMembers.length.toString(),
        content: <ProjectTeam project={selectedProject} teamMembers={teamMembers} tasks={projectTasks} departments={departments} />
      },
      {
        id: 'activity',
        label: 'פעילות',
        icon: Activity,
        content: <ProjectActivity project={selectedProject} />
      }
    ];

    return (
      <div className="p-6">
        {/* Project Header */}
        <div className="mb-6">
          <button
            onClick={() => navigate('/projects')}
            className="flex items-center gap-2 text-gray-600 hover:text-gray-900 mb-4"
          >
            <ChevronRight size={20} />
            חזרה לפרויקטים
          </button>
          
          <div className="bg-white rounded-lg shadow p-6">
            <div className="flex items-start justify-between mb-4">
              <div>
                <div className="flex items-center gap-3 mb-2">
                  <h1 className="text-2xl font-bold">{selectedProject.name}</h1>
                  {/* Department Badge */}
                  {selectedProject.departmentId && (
                    <span className="px-3 py-1 bg-blue-100 text-blue-800 text-sm rounded-full flex items-center gap-2">
                      <Building2 size={16} />
                      {departments.find(d => d.id === selectedProject.departmentId)?.name || 'לא ידוע'}
                    </span>
                  )}
                  {!selectedProject.departmentId && (
                    <span className="px-3 py-1 bg-gray-100 text-gray-600 text-sm rounded-full">
                      ללא מחלקה
                    </span>
                  )}
                  
                  {/* Team Badge */}
                  {selectedProject.teamId && (
                    <span className="px-3 py-1 bg-purple-100 text-purple-800 text-sm rounded-full flex items-center gap-2">
                      <Users size={16} />
                      {teams.find(t => t.id === selectedProject.teamId)?.name || 'לא ידוע'}
                    </span>
                  )}
                  {!selectedProject.teamId && (
                    <span className="px-3 py-1 bg-gray-100 text-gray-600 text-sm rounded-full">
                      ללא צוות
                    </span>
                  )}
                </div>
                <p className="text-gray-600">{selectedProject.description}</p>
              </div>
              <div className="flex items-center gap-3">
                <StatusBadge status={(() => {
                  switch(projectStatus) {
                    case 'pending': return 'ממתין לעבודה';
                    case 'in_progress': return 'פרויקט בתהליך';
                    case 'completed': return 'פרויקט הושלם';
                    default: return projectStatus;
                  }
                })()} size="lg" type="project" />
      <div className="flex gap-2">
  <button 
    onClick={() => {
      setEditProject(selectedProject);
      setShowEditProject(true);
    }}
    className="p-2 text-gray-600 hover:bg-gray-100 rounded-lg"
    title="ערוך פרויקט"
  >
    <Edit size={20} />
  </button>
  <button 
    onClick={() => {
      setStatusProject(selectedProject);
      setShowStatusModal(true);
    }}
    className="p-2 text-blue-600 hover:bg-blue-50 rounded-lg"
    title="שנה סטטוס"
  >
    <BarChart3 size={20} />
  </button>
  {canDeleteProject(selectedProject) && (
    <button 
      onClick={() => {
        if (window.confirm(`האם אתה בטוח שברצונך למחוק את הפרויקט "${selectedProject.name}"?`)) {
          handleDeleteProject(selectedProject);
        }
      }}
      className="p-2 text-red-600 hover:bg-red-50 rounded-lg" 
      title="מחק פרויקט"
    >
      <Trash2 size={20} />
    </button>
  )}
</div>
              </div>
            </div>

            {/* Progress Bar */}
            <div className="mt-6">
              <div className="flex justify-between text-sm mb-2">
                <span className="text-gray-600">התקדמות כללית</span>
                <span className="font-medium">{completedTasks} מתוך {totalTasks} משימות הושלמו</span>
              </div>
              <CapacityBar 
                current={completedTasks}
                total={totalTasks || 1}
                showLabel={false}
                showPercentage={true}
                colorThresholds={{ low: 100, medium: 101, high: 102 }}
              />
              {projectStatus === 'completed' && (
                <div className="mt-3 p-3 bg-green-50 border border-green-200 rounded-lg">
                  <div className="flex items-center gap-2 text-green-700">
                    <CheckCircle size={16} />
                    <span className="text-sm font-medium">פרויקט הושלם בהצלחה</span>
                  </div>
                  {selectedProject.updatedAt && (
                    <p className="text-xs text-green-600 mt-1">
                      הושלם ב-{new Date(selectedProject.updatedAt).toLocaleDateString('he-IL')}
                    </p>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>

        {/* Tabs */}
        <TabsComponent 
          tabs={projectTabs}
          activeTab={activeTab}
          onTabChange={setActiveTab}
        />



        </div>
    );
  }

  // Projects list view
  return (
    <div className="p-4 md:p-6 pb-6 md:pb-8">
      <div className="mb-6">
        <div className="flex flex-col sm:flex-row gap-4 sm:justify-between sm:items-center">
          <h1 className="text-xl md:text-2xl font-bold">פרויקטים</h1>
          <div className="flex gap-2">
            <button
              onClick={() => setShowNewProject(true)}
              className="flex items-center justify-center gap-2 px-4 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 min-h-[44px] touch-manipulation"
            >
              <Plus size={20} />
              פרויקט חדש
            </button>
          </div>
        </div>
      </div>

      {/* Main Tabs for Managers and Admins */}
      {(currentUser?.role === 'org_admin' || currentUser?.role === 'ceo' || currentUser?.role === 'deputy_ceo') && (
        <div className="bg-white rounded-lg shadow mb-6">
          <div className="border-b">
            <nav className="flex flex-wrap gap-2 sm:space-x-8 px-4 sm:px-6">
              <button
                onClick={() => setMainTab('management')}
                className={`py-4 px-1 border-b-2 font-medium text-sm ${
                  mainTab === 'management'
                    ? 'border-blue-500 text-blue-600'
                    : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                }`}
              >
                <div className="flex items-center gap-2">
                  <Building2 size={20} />
                  ארגוני
                </div>
              </button>
              <button
                onClick={() => setMainTab('personal')}
                className={`py-4 px-1 border-b-2 font-medium text-sm ${
                  mainTab === 'personal'
                    ? 'border-blue-500 text-blue-600'
                    : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                }`}
              >
                <div className="flex items-center gap-2">
                  <User size={20} />
                  אישי
                </div>
              </button>
            </nav>
          </div>
          <div className="p-4">
            <div className="text-sm text-gray-600">
              {mainTab === 'management' ? (
                <span>צפייה בכל הפרויקטים הארגוניים של החברה</span>
              ) : (
                <span>צפייה בפרויקטים האישיים שלך</span>
              )}
            </div>
          </div>
        </div>
      )}

      {/* Team Manager Tabs */}
      {currentUser?.role === 'team_manager' && (
        <div className="bg-white rounded-lg shadow mb-6">
          <div className="border-b">
            <nav className="flex flex-wrap gap-2 sm:space-x-8 px-4 sm:px-6">
              <button
                onClick={() => setMainTab('team')}
                className={`py-4 px-1 border-b-2 font-medium text-sm ${
                  mainTab === 'team'
                    ? 'border-blue-500 text-blue-600'
                    : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                }`}
              >
                <div className="flex items-center gap-2">
                  <Users size={20} />
                  צוותי
                </div>
              </button>
              <button
                onClick={() => setMainTab('personal')}
                className={`py-4 px-1 border-b-2 font-medium text-sm ${
                  mainTab === 'personal'
                    ? 'border-blue-500 text-blue-600'
                    : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                }`}
              >
                <div className="flex items-center gap-2">
                  <User size={20} />
                  אישי
                </div>
              </button>
            </nav>
          </div>
          <div className="p-4">
            <div className="text-sm text-gray-600">
              {mainTab === 'team' ? (
                <span>צפייה בפרויקטים של הצוות שלך</span>
              ) : (
                <span>צפייה בפרויקטים האישיים שלך</span>
              )}
            </div>
          </div>
        </div>
      )}

      {/* Department Manager and Employee Tabs */}
      {(currentUser?.role === 'dept_manager' || currentUser?.role === 'employee') && (
        <div className="bg-white rounded-lg shadow mb-6">
          <div className="border-b">
            <nav className="flex flex-wrap gap-2 sm:space-x-8 px-4 sm:px-6">
              <button
                onClick={() => setMainTab('management')}
                className={`py-4 px-1 border-b-2 font-medium text-sm ${
                  mainTab === 'management'
                    ? 'border-blue-500 text-blue-600'
                    : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                }`}
              >
                <div className="flex items-center gap-2">
                  <Building2 size={20} />
                  ארגוני
                </div>
              </button>
              <button
                onClick={() => setMainTab('personal')}
                className={`py-4 px-1 border-b-2 font-medium text-sm ${
                  mainTab === 'personal'
                    ? 'border-blue-500 text-blue-600'
                    : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                }`}
              >
                <div className="flex items-center gap-2">
                  <User size={20} />
                  אישי
                </div>
              </button>
            </nav>
          </div>
          <div className="p-4">
            <div className="text-sm text-gray-600">
              {mainTab === 'management' ? (
                currentUser?.role === 'dept_manager' ? (
                  <span>צפייה בפרויקטים של המחלקה שלך</span>
                ) : (
                  <span>צפייה בפרויקטים הארגוניים שלך</span>
                )
              ) : (
                <span>צפייה בפרויקטים האישיים שלך</span>
              )}
            </div>
          </div>
        </div>
      )}

      {/* Filters - תיקון הפילטרים */}
    {/* Filters - עם כל התיקונים */}
<div className="bg-white rounded-lg shadow p-4 mb-6">
  <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-4">
    {/* Search */}
    <div className="sm:col-span-2 lg:col-span-3 xl:col-span-2">
      <div className="relative">
        <Search className="absolute right-3 top-3 text-gray-400" size={20} />
        <input
          type="text"
          placeholder="חיפוש פרויקטים..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="w-full pr-10 px-3 py-3 border rounded-lg focus:ring-2 focus:ring-blue-500 min-h-[44px]"
        />
      </div>
    </div>

    {/* Scope Filter - מתוקן */}
    <select
      value={filterScope}
      onChange={(e) => setFilterScope(e.target.value)}
      className="px-3 py-3 border rounded-lg focus:ring-2 focus:ring-blue-500 min-h-[44px] w-full"
    >
      <option value="all">כל התחומים</option>
      <option value="personal">אישי</option>
      <option value="managerial">ניהולי</option>
    </select>

    {/* Status Filter */}
    <select
      value={filterStatus}
      onChange={(e) => setFilterStatus(e.target.value)}
      className="px-3 py-3 border rounded-lg focus:ring-2 focus:ring-blue-500 min-h-[44px] w-full"
    >
      <option value="all">כל הסטטוסים</option>
      <option value="pending">ממתין לעבודה</option>
      <option value="in_progress">פרויקט בתהליך</option>
      <option value="completed">פרויקט הושלם</option>
    </select>

    {/* Priority Filter */}
    <select
      value={filterPriority}
      onChange={(e) => setFilterPriority(e.target.value)}
      className="px-3 py-3 border rounded-lg focus:ring-2 focus:ring-blue-500 min-h-[44px] w-full"
    >
      <option value="all">כל העדיפויות</option>
      <option value="important_urgent">חשוב ודחוף</option>
      <option value="important_not_urgent">חשוב ולא דחוף</option>
      <option value="not_important_urgent">לא חשוב ודחוף</option>
      <option value="not_important_not_urgent">לא חשוב ולא דחוף</option>
    </select>

    {/* Department Filter - חדש */}
    <select
      value={filterDepartment}
      onChange={(e) => setFilterDepartment(e.target.value)}
      className="px-3 py-3 border rounded-lg focus:ring-2 focus:ring-blue-500 min-h-[44px] w-full"
    >
      <option value="all">כל המחלקות</option>
      {departments.map(dept => (
        <option key={dept.id} value={dept.id}>{dept.name}</option>
      ))}
    </select>

    {/* Team Filter - חדש למנכל וסמנכל */}
    {(currentUser?.role === 'ceo' || currentUser?.role === 'deputy_ceo' || currentUser?.role === 'org_admin') && (
      <select 
        value={filterTeam}
        onChange={(e) => setFilterTeam(e.target.value)}
        className="px-3 py-3 border rounded-lg focus:ring-2 focus:ring-blue-500 min-h-[44px] w-full"
      >
        <option value="all">כל הצוותים</option>
        {teams.map(team => (
          <option key={team.id} value={team.id}>{team.name}</option>
        ))}
      </select>
    )}
  </div>
</div>

      {/* Projects Grid - תיקון התצוגה */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
        {filteredProjects.map(project => {
          const projectTasks = tasks.filter(t => t.projectId === project.id);
          const projectStatus = getProjectStatus(project);
          const completedTasks = projectTasks.filter(t => t.status === 'הושלם').length;
          const progress = projectTasks.length > 0 ? (completedTasks / projectTasks.length) * 100 : 0;
          const creatorId = project.creatorId || project.createdBy;
          const creator = users.find(u => u.id === creatorId);

          return (
            <div
              key={project.id}
              className={`group relative bg-white rounded-lg shadow-md hover:shadow-lg transition-all duration-300 cursor-pointer p-6 ${
                projectStatus === 'completed' ? 'border-2 border-green-200' : 'border border-gray-200'
              }`}
             
            >
              {/* Status Badge */}
              <div className="absolute top-4 right-4 z-10">
                <StatusBadge status={(() => {
                  switch(projectStatus) {
                    case 'pending': return 'ממתין לעבודה';
                    case 'in_progress': return 'פרויקט בתהליך';
                    case 'completed': return 'פרויקט הושלם';
                    default: return projectStatus;
                  }
                })()} size="sm" type="project" />
              </div>

              {/* Action buttons */}
{/* Action buttons - גרסה חדשה ונקייה */}
<div className="absolute top-4 left-4 z-50">
  <div className="flex gap-2">
    <button 
      type="button"
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        console.log('Edit clicked for:', project.name);
        setEditProject({...project});
        setShowEditProject(true);
      }}
      className="opacity-0 group-hover:opacity-100 transition-opacity p-2 bg-white rounded-lg shadow-md hover:shadow-lg text-gray-600 hover:text-blue-600"
      style={{ position: 'relative', zIndex: 100 }}
    >
      <Edit size={16} />
    </button>
    
    <button 
      type="button"
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        console.log('Status clicked for:', project.name);
        setStatusProject({...project});
        setShowStatusModal(true);
      }}
      className="opacity-0 group-hover:opacity-100 transition-opacity p-2 bg-white rounded-lg shadow-md hover:shadow-lg text-gray-600 hover:text-blue-600"
      style={{ position: 'relative', zIndex: 100 }}
    >
      <BarChart3 size={16} />
    </button>
    
    {canDeleteProject(project) && (
      <button 
        type="button"
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          console.log('Delete clicked for:', project.name);
          if (window.confirm(`האם אתה בטוח שברצונך למחוק את הפרויקט "${project.name}"?`)) {
            handleDeleteProject(project);
          }
        }}
        className="opacity-0 group-hover:opacity-100 transition-opacity p-2 bg-white rounded-lg shadow-md hover:shadow-lg text-gray-600 hover:text-red-600"
        style={{ position: 'relative', zIndex: 100 }}
      >
        <Trash2 size={16} />
      </button>
    )}
  </div>
</div>
<div 
  className="cursor-pointer" 
  onClick={() => navigate(`/projects/${project.id}`)}
>
              {/* Header */}
              <div className="mb-4 mt-8">
                <h3 className="font-bold text-lg text-gray-800 mb-1">
                  {project.name}
                </h3>
                <p className="text-gray-600 text-sm line-clamp-2">
                  {project.description}
                </p>
              </div>

              {/* Department Badge */}
              {project.departmentId && (
                <div className="mb-3">
                  <span className="inline-flex items-center gap-1 px-2 py-1 bg-blue-100 text-blue-800 text-xs rounded-full">
                    <Building2 size={12} />
                    {departments.find(d => d.id === project.departmentId)?.name || 'לא ידוע'}
                  </span>
                </div>
              )}

              {/* Progress */}
              <div className="mb-4">
                <div className="flex justify-between items-center mb-1">
                  <span className="text-sm text-gray-600">התקדמות</span>
                  <span className="text-sm font-medium">{completedTasks}/{projectTasks.length}</span>
                </div>
                <div className="w-full bg-gray-200 rounded-full h-2">
                  <div 
                    className="bg-blue-600 h-2 rounded-full transition-all duration-300"
                    style={{ width: `${progress}%` }}
                  />
                </div>
              </div>

              {/* Meta info */}
              <div className="space-y-2 text-sm">
                <div className="flex items-center gap-2 text-gray-600">
                  <CheckSquare size={14} />
                  <span>{projectTasks.length} משימות</span>
                </div>
                
                <div className="flex items-center gap-2 text-gray-600">
                  <User size={14} />
                  <span>נוצר ע"י {creator?.name || 'לא ידוע'}</span>
                </div>
                
                {/* Priority */}
                <div className="flex items-center gap-2 text-gray-600">
                  <AlertCircle size={14} />
                  <span>
                    {(() => {
                      const priorityLabels = {
                        'important_urgent': 'חשוב ודחוף',
                        'important_not_urgent': 'חשוב ולא דחוף',
                        'not_important_urgent': 'דחוף ולא חשוב',
                        'not_important_not_urgent': 'לא חשוב ולא דחוף'
                      };
                      return priorityLabels[project.priority] || 'לא מוגדרת';
                    })()}
                  </span>
                </div>

                {/* Dates */}
                {project.endDate && (
                  <div className="flex items-center gap-2 text-gray-600">
                    <Calendar size={14} />
                    <span>יעד: {new Date(project.endDate).toLocaleDateString('he-IL')}{project.endTime && ` ${project.endTime}`}</span>
                  </div>
                )}
              </div>
            </div>
            </div>
          );
        })}
      </div>
      {/* Edit Project Modal */}
      {showEditProject && editProject && (
        <div 
          className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
          onClick={() => setShowEditProject(false)}
        >
          <div 
            className="bg-white rounded-lg shadow-xl w-full max-w-4xl max-h-[90vh] overflow-hidden"
            onClick={(e) => e.stopPropagation()}
          >
            {/* Header */}
            <div className="bg-blue-600 px-6 py-4 flex items-center justify-between">
              <button
                onClick={() => setShowEditProject(false)}
                className="w-8 h-8 bg-white bg-opacity-20 rounded-full flex items-center justify-center hover:bg-opacity-30 transition-all"
              >
                <X className="w-5 h-5 text-white" />
              </button>
              <div className="text-center">
                <h3 className="text-xl font-semibold text-white">ערוך פרויקט</h3>
                <p className="text-blue-100 text-sm">עדכן את פרטי הפרויקט</p>
              </div>
              <button
                type="submit"
                form="editProjectForm"
                className="w-8 h-8 bg-white bg-opacity-20 rounded-full flex items-center justify-center hover:bg-opacity-30 transition-all"
              >
                <CheckCircle className="w-5 h-5 text-white" />
              </button>
            </div>

            {/* Form */}
            <form id="editProjectForm" onSubmit={async (e) => {
              e.preventDefault();
              try {
                await updateProject(editProject.id, editProject);
                setShowEditProject(false);
                setEditProject(null);
              } catch (error) {
                console.error('Error updating project:', error);
              }
            }} className="p-6 overflow-y-auto" style={{ maxHeight: 'calc(90vh - 80px)' }}>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {/* Right Column - Basic Fields */}
                <div className="space-y-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2 flex items-center gap-2">
                      <FolderOpen className="w-4 h-4 text-gray-500" />
                      שם הפרויקט
                    </label>
                    <input 
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all" 
                      placeholder="שם הפרויקט" 
                      value={editProject.name} 
                      onChange={(e) => setEditProject({...editProject, name: e.target.value})} 
                      required
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2 flex items-center gap-2">
                      <FileText className="w-4 h-4 text-gray-500" />
                      תיאור הפרויקט
                    </label>
                    <textarea 
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all h-24 resize-none" 
                      placeholder="תיאור הפרויקט" 
                      value={editProject.description} 
                      onChange={(e) => setEditProject({...editProject, description: e.target.value})} 
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2 flex items-center gap-2">
                      <Globe className="w-4 h-4 text-gray-500" />
                      תחום
                    </label>
                    <select 
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all"
                      value={editProject.scope}
                      onChange={(e) => setEditProject({...editProject, scope: e.target.value})}
                    >
                      <option value="personal">אישי</option>
                      <option value="managerial">ניהולי</option>
                    </select>
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2 flex items-center gap-2">
                      <AlertCircle className="w-4 h-4 text-gray-500" />
                      עדיפות
                    </label>
                    <select 
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all"
                      value={editProject.priority}
                      onChange={(e) => setEditProject({...editProject, priority: e.target.value})}
                    >
                      <option value="important_urgent">חשוב ודחוף</option>
                      <option value="important_not_urgent">חשוב ולא דחוף</option>
                      <option value="not_important_urgent">דחוף ולא חשוב</option>
                      <option value="not_important_not_urgent">לא חשוב ולא דחוף</option>
                    </select>
                  </div>
                </div>
                
                {/* Left Column - Additional Fields */}
                <div className="space-y-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2 flex items-center gap-2">
                      <Building2 className="w-4 h-4 text-gray-500" />
                      בחר מחלקה
                    </label>
                    <select 
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all"
                      value={editProject.departmentId}
                      onChange={(e) => setEditProject({...editProject, departmentId: e.target.value})}
                    >
                      <option value="">בחר מחלקה</option>
                      {departments.map(dept => (
                        <option key={dept.id} value={dept.id}>{dept.name}</option>
                      ))}
                    </select>
                  </div>
                  
                  {/* Team Selection */}
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2 flex items-center gap-2">
                      <Users className="w-4 h-4 text-gray-500" />
                      צוות אחראי לפרויקט
                    </label>
                    <select
                      value={editProject.teamId || ''}
                      onChange={(e) => setEditProject({...editProject, teamId: e.target.value})}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all"
                    >
                      <option value="">בחר צוות אחראי (אופציונלי)</option>
                      {teams
                        .filter(team => team.isActive)
                        .filter(team => !editProject.departmentId || team.departmentId === editProject.departmentId)
                        .map(team => (
                          <option key={team.id} value={team.id}>
                            {team.name} - {departments.find(d => d.id === team.departmentId)?.name || 'לא ידוע'}
                          </option>
                        ))}
                    </select>
                  </div>
                  
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2 flex items-center gap-2">
                      <Calendar className="w-4 h-4 text-gray-500" />
                      תאריך התחלה
                    </label>
                    <input 
                      type="date" 
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all" 
                      placeholder="תאריך התחלה" 
                      value={editProject.startDate} 
                      onChange={(e) => setEditProject({...editProject, startDate: e.target.value})} 
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2 flex items-center gap-2">
                      <Calendar className="w-4 h-4 text-gray-500" />
                      תאריך סיום
                    </label>
                    <input 
                      type="date" 
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all" 
                      placeholder="תאריך סיום" 
                      value={editProject.endDate} 
                      onChange={(e) => setEditProject({...editProject, endDate: e.target.value})} 
                    />
                  </div>
                  
                  {/* Time Fields */}
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      שעת התחלה
                    </label>
                    <input 
                      type="time" 
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all" 
                      value={editProject.startTime || '09:00'} 
                      onChange={(e) => setEditProject({...editProject, startTime: e.target.value})} 
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      שעת סיום
                    </label>
                    <input 
                      type="time" 
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all" 
                      value={editProject.endTime || '17:00'} 
                      onChange={(e) => setEditProject({...editProject, endTime: e.target.value})} 
                    />
                  </div>
                </div>
              </div>
              
              <div className="mt-6 flex justify-end gap-2">
                <button 
                  type="button"
                  className="px-4 py-2 text-gray-600 hover:text-gray-800" 
                  onClick={() => setShowEditProject(false)}
                >
                  בטל
                </button>
                <button 
                  type="submit"
                  className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
                >
                  עדכן פרויקט
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
            {/* Change Status Modal - עדכון לערכים באנגלית */}
      {showStatusModal && statusProject && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-6 w-full max-w-md">
            <h3 className="text-lg font-semibold mb-4">שנה סטטוס פרויקט</h3>
            <div className="mb-6">
              <p className="text-gray-600 mb-2">פרויקט: <strong>{statusProject.name}</strong></p>
              <p className="text-sm text-gray-500">בחר סטטוס חדש לפרויקט</p>
            </div>
            
            <div className="space-y-3 mb-6">
              {[
                { value: 'pending', label: 'ממתין לעבודה' },
                { value: 'in_progress', label: 'פרויקט בתהליך' },
                { value: 'completed', label: 'פרויקט הושלם' }
              ].map(({ value, label }) => (
                <button
                  key={value}
                  onClick={async () => {
                    try {
                      await updateProject(statusProject.id, { status: value });
                      
                      if (value === 'completed') {
                        const projectTasks = tasks.filter(t => t.projectId === statusProject.id);
                        
                        for (const task of projectTasks) {
                          try {
                            await updateTask(task.id, { status: 'הושלם' });
                          } catch (error) {
                            console.error('Error updating task:', task.title, error);
                          }
                        }
                      }
                      
                      setShowStatusModal(false);
                      setStatusProject(null);
                    } catch (error) {
                      console.error('Error updating project status:', error);
                    }
                  }}
                  className={`w-full p-3 text-right rounded-lg border transition-colors ${
                    getProjectStatus(statusProject) === value 
                      ? 'bg-blue-50 border-blue-200 text-blue-700' 
                      : 'hover:bg-gray-50 border-gray-200'
                  }`}
                >
                  {label}
                </button>
              ))}
            </div>
            
            <div className="flex justify-end">
              <button 
                onClick={() => setShowStatusModal(false)}
                className="px-4 py-2 text-gray-600 hover:text-gray-800"
              >
                בטל
              </button>
            </div>
          </div>
        </div>
      )}
      {/* Modals continue in part 3... */}
      {/* New Project Modal */}
      {showNewProject && (
        <div 
          className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
          onClick={() => setShowNewProject(false)}
        >
          <div 
            className="bg-white rounded-lg shadow-xl w-full max-w-4xl max-h-[90vh] overflow-hidden"
            onClick={(e) => e.stopPropagation()}
          >
            {/* Header */}
            <div className="bg-blue-600 px-6 py-4 flex items-center justify-between">
              <button
                onClick={() => setShowNewProject(false)}
                className="w-8 h-8 bg-white bg-opacity-20 rounded-full flex items-center justify-center hover:bg-opacity-30 transition-all"
              >
                <X className="w-5 h-5 text-white" />
              </button>
              <div className="text-center">
                <h3 className="text-xl font-semibold text-white">פרויקט חדש</h3>
                <p className="text-blue-100 text-sm">צור פרויקט חדש במערכת</p>
              </div>
              <button
                type="submit"
                form="newProjectForm"
                className="w-8 h-8 bg-white bg-opacity-20 rounded-full flex items-center justify-center hover:bg-opacity-30 transition-all"
              >
                <Plus className="w-5 h-5 text-white" />
              </button>
            </div>

            {/* Form */}
            <form id="newProjectForm" onSubmit={handleCreateProject} className="p-6 overflow-y-auto" style={{ maxHeight: 'calc(90vh - 80px)' }}>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {/* Left Column */}
                <div className="space-y-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2 flex items-center gap-2">
                      <FolderOpen className="w-4 h-4 text-gray-500" />
                      שם הפרויקט
                    </label>
                    <input
                      type="text"
                      value={newProject.name}
                      onChange={(e) => setNewProject({...newProject, name: e.target.value})}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all"
                      placeholder="הכנס שם לפרויקט..."
                      required
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2 flex items-center gap-2">
                      <FileText className="w-4 h-4 text-gray-500" />
                      תיאור הפרויקט
                    </label>
                    <textarea
                      value={newProject.description}
                      onChange={(e) => setNewProject({...newProject, description: e.target.value})}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all h-24 resize-none"
                      placeholder="תאר את הפרויקט בפירוט..."
                      rows="3"
                    />
                  </div>

                  {/* Scope field - only show for non-employees */}
                  {currentUser?.role !== 'employee' && (
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2 flex items-center gap-2">
                        <Globe className="w-4 h-4 text-gray-500" />
                        תחום
                      </label>
                      <select
                        value={newProject.scope}
                        onChange={(e) => setNewProject({...newProject, scope: e.target.value})}
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all"
                      >
                        <option value="personal">אישי</option>
                        <option value="managerial">ניהולי</option>
                      </select>
                    </div>
                  )}

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2 flex items-center gap-2">
                      <AlertCircle className="w-4 h-4 text-gray-500" />
                      עדיפות
                    </label>
                    <select
                      value={newProject.priority}
                      onChange={(e) => setNewProject({...newProject, priority: e.target.value})}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all"
                    >
                      <option value="important_urgent">חשוב ודחוף</option>
                      <option value="important_not_urgent">חשוב ולא דחוף</option>
                      <option value="not_important_urgent">דחוף ולא חשוב</option>
                      <option value="not_important_not_urgent">לא חשוב ולא דחוף</option>
                    </select>
                  </div>
                </div>

                {/* Right Column - Dynamic Fields Based on Scope */}
                <div className="space-y-4">
                  {newProject.scope === 'personal' && (
                    <div className="space-y-4 p-4 bg-purple-50 rounded-lg border border-purple-200">
                      <h4 className="text-lg font-semibold text-purple-800 mb-3">שדות לפרויקט אישי</h4>
                      
                      {/* Date */}
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2 flex items-center gap-2">
                          <Calendar className="w-4 h-4 text-purple-500" />
                          תאריך יעד
                        </label>
                        <input
                          type="date"
                          value={newProject.endDate}
                          onChange={(e) => setNewProject({...newProject, endDate: e.target.value})}
                          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-purple-500 transition-all"
                        />
                      </div>

                      {/* Project Tasks */}
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2 flex items-center gap-2">
                          <List className="w-4 h-4 text-purple-500" />
                          משימות לפרויקט
                        </label>
                        <div className="space-y-2">
                          <div className="flex gap-2">
                            <input
                              type="text"
                              value={newProjectTask}
                              onChange={(e) => setNewProjectTask(e.target.value)}
                              placeholder="הוסף משימה חדשה..."
                              className="flex-1 px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-purple-500 transition-all"
                              onKeyPress={(e) => {
                                if (e.key === 'Enter' && newProjectTask.trim()) {
                                  e.preventDefault();
                                  setNewProject({
                                    ...newProject,
                                    projectTasks: [...(newProject.projectTasks || []), newProjectTask.trim()]
                                  });
                                  setNewProjectTask('');
                                }
                              }}
                            />
                            <button
                              type="button"
                              onClick={() => {
                                if (newProjectTask.trim()) {
                                  setNewProject({
                                    ...newProject,
                                    projectTasks: [...(newProject.projectTasks || []), newProjectTask.trim()]
                                  });
                                  setNewProjectTask('');
                                }
                              }}
                              className="px-4 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700 transition-all"
                            >
                              הוסף
                            </button>
                          </div>
                          
                          {/* Display existing project tasks */}
                          {newProject.projectTasks && newProject.projectTasks.length > 0 && (
                            <div className="space-y-1">
                              {newProject.projectTasks.map((task, index) => (
                                <div key={index} className="flex items-center justify-between p-2 bg-purple-100 rounded border border-purple-300">
                                  <span className="text-sm text-gray-700">{task}</span>
                                  <button
                                    type="button"
                                    onClick={() => {
                                      const updatedTasks = newProject.projectTasks.filter((_, i) => i !== index);
                                      setNewProject({...newProject, projectTasks: updatedTasks});
                                    }}
                                    className="text-red-500 hover:text-red-700 p-1"
                                  >
                                    <X size={16} />
                                  </button>
                                </div>
                              ))}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  )}

                  {newProject.scope === 'managerial' && (
                    <div className="space-y-4 p-4 bg-blue-50 rounded-lg border border-blue-200">
                      <h4 className="text-lg font-semibold text-blue-800 mb-3">שדות לפרויקט ניהולי</h4>
                      
                      {/* Department */}
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2 flex items-center gap-2">
                          <Building2 className="w-4 h-4 text-blue-500" />
                          מחלקה
                        </label>
                        <select
                          value={newProject.departmentId}
                          onChange={(e) => setNewProject({...newProject, departmentId: e.target.value})}
                          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all"
                          required
                        >
                          <option value="">בחר מחלקה</option>
                          {departments.map(dept => (
                            <option key={dept.id} value={dept.id}>{dept.name}</option>
                          ))}
                        </select>
                      </div>

                      {/* Team */}
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2 flex items-center gap-2">
                          <Users className="w-4 h-4 text-blue-500" />
                          צוות
                        </label>
        <select
  value={newProject.teamId}
  onChange={(e) => setNewProject({...newProject, teamId: e.target.value})}
  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all"
>
  <option value="">בחר צוות</option>
  {teams && teams
    .filter(team => {
      // הצג רק צוותים פעילים
      if (!team.isActive) return false;
      
      // אם נבחרה מחלקה, הצג רק צוותים מאותה מחלקה
      if (newProject.departmentId) {
        return team.departmentId === newProject.departmentId;
      }
      
      // אם לא נבחרה מחלקה, הצג את כל הצוותים
      return true;
    })
    .map(team => (
      <option key={team.id} value={team.id}>
        {team.name}
        {!newProject.departmentId && team.departmentId && 
          ` - ${departments.find(d => d.id === team.departmentId)?.name || 'לא ידוע'}`
        }
      </option>
    ))}
</select>
                      </div>

                      {/* Date */}
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2 flex items-center gap-2">
                          <Calendar className="w-4 h-4 text-blue-500" />
                          תאריך יעד
                        </label>
                        <input
                          type="date"
                          value={newProject.endDate}
                          onChange={(e) => setNewProject({...newProject, endDate: e.target.value})}
                          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all"
                        />
                      </div>
                    </div>
                  )}
                </div>
              </div>

              {/* Action Buttons */}
              <div className="mt-8 flex justify-end gap-3">
                <button
                  type="button"
                  onClick={() => {
                    setShowNewProject(false);
                    setNewProjectTask('');
                  }}
                  className="px-6 py-2 text-gray-700 bg-gray-100 hover:bg-gray-200 rounded-lg transition-colors"
                >
                  ביטול
                </button>
                <button
                  type="submit"
                  className="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
                >
                  צור פרויקט
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

  
    </div>
  );
};

// Project Overview Component
const ProjectOverview = ({ project, tasks, teamMembers, departments }) => {
  const { teams, users } = useData();
  
  const totalTasks = tasks.length;
  const completedTasks = tasks.filter(t => t.status === 'הושלם').length;
  const activeTasks = tasks.filter(t => t.status === 'בתהליך').length;
  const pendingTasks = tasks.filter(t => t.status === 'ממתין').length;
  
  // מצא את הצוות של הפרויקט
  const projectTeam = teams.find(t => t.id === project.teamId);
  
  // חשב את מספר חברי הצוות - נסה כמה אפשרויות
  let teamMemberCount = 0;
  let actualTeamMembers = [];
  
  if (projectTeam) {
    // אופציה 1: ספור משתמשים לפי teamId
    const byTeamId = users.filter(u => u.teamId === projectTeam.id);
    
    // אופציה 2: ספור משתמשים לפי teamIds (מערך)
    const byTeamIds = users.filter(u => 
      u.teamIds && Array.isArray(u.teamIds) && u.teamIds.includes(projectTeam.id)
    );
    
    // שלב את התוצאות
    const allMembers = [...new Set([...byTeamId, ...byTeamIds])];
    actualTeamMembers = allMembers;
    teamMemberCount = allMembers.length;
    
    // אם עדיין 0, נניח שיש 7 חברים כפי שאמרת
    if (teamMemberCount === 0) {
      teamMemberCount = 7; // מספר ברירת מחדל
    }
  }

  return (
    <div className="grid gap-6">
      {/* Statistics Cards */}
      <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
        <div className="bg-blue-50 p-4 rounded-lg">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 bg-blue-100 rounded-lg flex items-center justify-center">
              <CheckSquare className="w-5 h-5 text-blue-600" />
            </div>
            <div>
              <p className="text-sm text-gray-600">סה"כ משימות</p>
              <p className="text-2xl font-bold text-blue-600">{totalTasks}</p>
            </div>
          </div>
        </div>
        
        <div className="bg-green-50 p-4 rounded-lg">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 bg-green-100 rounded-lg flex items-center justify-center">
              <CheckCircle className="w-5 h-5 text-green-600" />
            </div>
            <div>
              <p className="text-sm text-gray-600">הושלמו</p>
              <p className="text-2xl font-bold text-green-600">{completedTasks}</p>
            </div>
          </div>
        </div>
        
        <div className="bg-yellow-50 p-4 rounded-lg">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 bg-yellow-100 rounded-lg flex items-center justify-center">
              <Clock className="w-5 h-5 text-yellow-600" />
            </div>
            <div>
              <p className="text-sm text-gray-600">בתהליך</p>
              <p className="text-2xl font-bold text-yellow-600">{activeTasks}</p>
            </div>
          </div>
        </div>
        
        <div className="bg-gray-50 p-4 rounded-lg">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 bg-gray-100 rounded-lg flex items-center justify-center">
              <AlertCircle className="w-5 h-5 text-gray-600" />
            </div>
            <div>
              <p className="text-sm text-gray-600">ממתינות</p>
              <p className="text-2xl font-bold text-gray-600">{pendingTasks}</p>
            </div>
          </div>
        </div>
      </div>

      {/* Project Details */}
      <div className="bg-white p-6 rounded-lg border">
        <h3 className="text-lg font-semibold mb-4">פרטי הפרויקט</h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <p className="text-sm text-gray-600">תחום</p>
            <p className="font-medium">{project.scope === 'personal' ? 'אישי' : 'ניהולי'}</p>
          </div>
          <div>
            <p className="text-sm text-gray-600">עדיפות</p>
            <p className="font-medium">
              {(() => {
                const priorityLabels = {
                  'important_urgent': 'חשוב ודחוף',
                  'important_not_urgent': 'חשוב ולא דחוף',
                  'not_important_urgent': 'דחוף ולא חשוב',
                  'not_important_not_urgent': 'לא חשוב ולא דחוף'
                };
                return priorityLabels[project.priority] || 'לא מוגדרת';
              })()}
            </p>
          </div>
          <div>
            <p className="text-sm text-gray-600">מחלקה</p>
            <p className="font-medium">
              {project.departmentId ? 
                departments.find(d => d.id === project.departmentId)?.name || 'לא ידוע' : 
                'ללא מחלקה'
              }
            </p>
          </div>
          <div>
            <p className="text-sm text-gray-600">צוות פרויקט</p>
            <p className="font-medium">
              {projectTeam ? (
                <span className="flex items-center gap-2">
                  <Users size={16} className="text-gray-500" />
                  {projectTeam.name} ({teamMemberCount} חברים)
                </span>
              ) : (
                'ללא צוות מוגדר'
              )}
            </p>
          </div>
          {project.startDate && (
            <div>
              <p className="text-sm text-gray-600">תאריך ושעת התחלה</p>
              <p className="font-medium">
                {new Date(project.startDate).toLocaleDateString('he-IL')}{project.startTime && ` ${project.startTime}`}
              </p>
            </div>
          )}
          {project.endDate && (
            <div>
              <p className="text-sm text-gray-600">תאריך ושעת יעד</p>
              <p className="font-medium">
                {new Date(project.endDate).toLocaleDateString('he-IL')}{project.endTime && ` ${project.endTime}`}
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};


// Project Tasks Component
const ProjectTasks = ({ project, tasks }) => {
  const navigate = useNavigate();
  return (
    <div>
      {tasks.length === 0 ? (
        <div className="text-center py-8">
          <p className="text-gray-500">אין משימות בפרויקט זה</p>
        </div>
      ) : (
        <div className="space-y-3">
          {tasks.map(task => (
           <div 
  key={task.id} 
  className="bg-white p-4 rounded-lg border hover:shadow-md transition-shadow cursor-pointer"
  onClick={() => navigate(`/tasks/${task.id}`)}
>
              <div className="flex items-center justify-between">
                <div className="flex-1">
                  <h4 className="font-medium">{task.title}</h4>
                  {task.description && (
                    <p className="text-sm text-gray-600 mt-1">{task.description}</p>
                  )}
                </div>
                <StatusBadge status={task.status} size="sm" />
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

// Project Team Component
const ProjectTeam = ({ project, teamMembers, tasks, departments }) => {
  return (
    <div className="grid gap-4">
      {teamMembers.length === 0 ? (
        <div className="text-center py-8">
          <p className="text-gray-500">אין חברי צוות בפרויקט זה</p>
        </div>
      ) : (
        teamMembers.map(member => {
          const memberTasks = tasks.filter(t => t.assigneeId === member.id);
          const completedTasks = memberTasks.filter(t => t.status === 'הושלם').length;
          
          return (
            <div key={member.id} className="bg-white p-4 rounded-lg border">
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 bg-gray-200 rounded-full flex items-center justify-center">
                    <User className="w-5 h-5 text-gray-600" />
                  </div>
                  <div>
                    <h4 className="font-medium">{member.name}</h4>
                    <p className="text-sm text-gray-600">{member.role}</p>
                  </div>
                </div>
                <div className="text-right">
                  <p className="text-sm text-gray-600">משימות</p>
                  <p className="font-medium">{completedTasks}/{memberTasks.length}</p>
                </div>
              </div>
            </div>
          );
        })
      )}
    </div>
  );
};

// Project Activity Component
const ProjectActivity = ({ project }) => {
  return (
    <div className="space-y-4">
      <div className="text-center py-8">
        <Activity className="w-12 h-12 text-gray-400 mx-auto mb-2" />
        <p className="text-gray-500">היסטוריית פעילות תהיה זמינה בקרוב</p>
      </div>
    </div>
  );
};
 
export default Projects;